export default "__VITE_ASSET__Cj3Qx0W3__"